/** Bound third-party loading without letting a stalled checkout trap the page. */
export async function checkoutTimeout<T>(promise: Promise<T>, milliseconds = 25_000): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      promise,
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => reject(new Error("Das Zahlungsformular konnte nicht geladen werden. Bitte erneut versuchen.")), milliseconds);
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}
